import {
  ADD_PRODUCTS_TO_LIST,
  CLEAR_PRODUCTS,
  DELETE_PRODUCTS_FROM_LIST,
  EDIT_PRODUCTS_IN_LIST,
  SET_PRODUCTS,
} from '../types/products-types';

import { productsInitialState } from 'store/initial-states/products-initial-state';

export const productsReducer = (state = productsInitialState, action) => {
  switch (action.type) {
    case SET_PRODUCTS:
      return action.payload;
    case ADD_PRODUCTS_TO_LIST:
      return [...state.products, action.payload];
    case EDIT_PRODUCTS_IN_LIST:
      return state.products.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload.updatedData } : item
      );
    case DELETE_PRODUCTS_FROM_LIST:
      return state.products.filter((item) => item.id !== action.payload);
    case CLEAR_PRODUCTS:
      return productsInitialState;
    default:
      return state;
  }
};
